<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_isVisible') || '是否可见'"
            prop="isVisible"
          >
            <el-radio-group v-model="formData.isVisible" :disabled="disabled">
              <el-radio label="Y">{{
                $l('form_label_isVisible_Y') || '是'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_label_isVisible_N') || '否'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_isLast') || '是否末级'"
            prop="isLast"
          >
            <el-radio-group v-model="formData.isLast" :disabled="disabled">
              <el-radio label="Y">{{
                $l('form_label_isLast_Y') || '是'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_label_isLast_N') || '否'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_funcID') || '功能编号'"
            prop="funcID"
          >
            <el-input
              clearable
              v-model="formData.funcID"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="10"
              :disabled="!this.isAdd"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_PID') || '上级功能编号'"
            prop="pid"
          >
            <el-cascader
              :options="functionTree"
              :props="{
                emitPath: false,
                checkStrictly: true,
                value: 'funcID',
                label: 'titleText',
              }"
              ref="cascaderFunctionTreeRef"
              v-model="formData.pid"
              clearable
              style="width: 100%"
              @change="calculateClassLevel"
              :disabled="!this.isAdd"
            >
              <template slot-scope="{ node, data }">
                <span>{{ data.titleText }}</span>
                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_classLevel') || '功能层级'"
            prop="classLevel"
          >
            <el-input-number
              clearable
              style="width: 100%"
              v-model="formData.classLevel"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              :min="0"
              :max="100000000"
              :disabled="!this.isAdd"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_enText') || '英文名称'"
            prop="enText"
          >
            <el-input
              clearable
              v-model="formData.enText"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_titleText') || '功能标题'"
            prop="titleText"
          >
            <el-input
              clearable
              v-model="formData.titleText"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_menuWebPageUrl') || '页面URL地址'"
          >
            <el-input
              clearable
              v-model="formData.menuWebPageUrl"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_formType') || '页面类型'"
            prop="formType"
          >
            <el-input
              clearable
              v-model="formData.formType"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_funcIcon') || '功能图标名称'">
            <el-input
              clearable
              v-model="formData.funcIcon"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="1000"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_appName') || '所属应用'">
            <el-input
              clearable
              v-model="formData.appNameLabel"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_sortOrder') || '页面类型'"
            prop="sortOrder"
          >
            <el-input-number
              clearable
              v-model="formData.sortOrder"
              style="width: 100%"
              :placeholder="
                $l('INDEX.tips_input_placeholder') || '功能排列顺序'
              "
              size="small"
              :min="0"
              :max="100000000"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_descText') || '功能描述'">
            <el-input
              type="textarea"
              :rows="2"
              clearable
              v-model="formData.descText"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <button-table
      ref="buttonTableRef"
      :tableData="tableData"
      :disabled="disabled"
      :isAdd="!this.isAdd"
      :tablePage="page"
      :formData="formData"
      @reload="reload"
    ></button-table>
  </div>
</template>
<script>
import ButtonTable from './table'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { ButtonTable },
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    funcID: String,
    isAdd: Boolean,
    classLevel: { type: Number, default: 0 },
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      page: {
        curPage: 1,
        pageSize: 10,
      },
      tableData: [],
      functionTree: [],
      formData: { isVisible: 'Y', isLast: 'Y', funcID: '' },
      rules: {
        funcID: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        pid: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'blur',
          },
        ],
        classLevel: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        titleText: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        isVisible: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        sortOrder: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        enText: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.getData()
    this.getTreeData()
  },
  computed: {},
  methods: {
    getTreeData() {
      let reqFuncId = this.funcID
      if(!this.disabled) {
        reqFuncId = ''
      }
      this.$api
        .sysMerchantFunctionTreeApi({
          funcID: reqFuncId
        })
        .then((res) => {
          this.functionTree = res.body.data
        })
        .catch(() => {})
    },
    reload() {
      this.getData()
    },
    getData() {
      if (!this.funcID) return
      if (this.isAdd) {
        this.formData.funcID = this.funcID
        this.formData.pid = this.funcID
        this.formData.classLevel = this.classLevel + 1
        return
      }
      this.$api
        .sysMerchantFunctionDetailApi({
          funcID: this.funcID,
        })
        .then((res) => {
          this.formData = res.body
          this.tableData = res.body.buttonDetailDtos
        })
    },
    calculateClassLevel() {
      const node = this.$refs.cascaderFunctionTreeRef.getCheckedNodes()
      if (node && node.length) {
        this.formData.classLevel = node[0].level + 1
        this.formData.funcID = node[0].value
      }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      const reviseData = this.$refs.buttonTableRef.getReviseButtonInfoList()
      this.$api
        .sysMerchantFunctionSaveApi({ ...this.formData, ...reviseData })
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_update_ok') || '保存成功！',
            type: 'success',
          })
          this.closeCurPage()
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    closeCurPage() {
      // 关闭当前页面
      this.$emit('close')
    },
  },
}
</script>
